import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Row, Col, Modal, ModalHeader, ModalBody, FormGroup, CustomInput, Label } from 'reactstrap';
import Chart from "react-apexcharts";

import { QUADRANTS_INNOVATIVE } from '../../../core/constants'
import graphic_report_mask from '../../../assets/img/graphic-report-mask.png'
import icon_members from '../../../assets/img/member-avatar.svg';

import TalentsListMembers from './talents-list-members'
import QuadrantsDetail from './quadrants-detail'
import { getCurrentTeamTopTalents, teamsTopTalentsListActions } from '../../../core/teams-top-talents-list';
import { capitalizeFirstLetter } from '../../../core/helper';

class ThinkingTalents extends Component {
  constructor(props) {
    super(props)

    this.state = {
      animationClassTabs: {
        enter: 'animate__animated',
        enterActive: 'animate__animated animate__fadeIn',
        exit: 'animate__animated',
        exitActive: 'animate__animated animate__fadeOut',
      },
      show_modal: false,
      data_modal: null,
      show_type: null,
      isOpen: false,
      energyAlways: true,
      energyLabel: 'active-always',
      quadrant_id: null,
      donutGraphOptions: {
        series: [],
        chart: {
          type: 'donut',
          events: {
            // Over
            dataPointMouseEnter: function(event, chartContext, config) {
              const hoveredElement = event.target.closest('.apexcharts-series');
              const seriesElements = document.querySelectorAll('.apexcharts-series');
              const seriesElementsLabels = document.querySelectorAll('.apexcharts-datalabels');
              
              // Add inactive class to all series elements and labels except the hovered one
              [...seriesElements, ...seriesElementsLabels].forEach(el => {
                if (el !== hoveredElement) {
                  el.classList.add('legend-mouseover-inactive');
                } else {
                  el.classList.remove('legend-mouseover-inactive');
                }
              });
            },
            dataPointMouseLeave: function(event, chartContext, config) {
              const seriesElements = document.querySelectorAll('.apexcharts-series');
              const seriesElementsLabels = document.querySelectorAll('.apexcharts-datalabels');

              // Remove inactive class from all series elements and labels
              [...seriesElements, ...seriesElementsLabels].forEach(el => {
                el.classList.remove('legend-mouseover-inactive');
              });
            }
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          },
          hover: {
            filter: {
              type: 'none',
            }
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%',
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: false,
                  align: 'center',
                  offsetY: 0,
                  label: 'Always Energy',
                  fontSize: '14px',
                  fontFamily: 'DM Sans',
                  fontWeight: 600,
                  formatter: function (w) {
                    return ''
                  }
                },
                name: {
                  show: true,
                  fontSize: '14px',
                  fontFamily: 'DM Sans',
                  fontWeight: 600,
                  color: undefined,
                  offsetY: 0,
                  formatter: function (val) {
                    return val
                  }
                },
                value: {
                  show: false,
                  fontSize: '14px',
                  fontFamily: 'DM Sans',
                  fontWeight: 700,
                  color: undefined,
                  offsetY: 0,
                  formatter: function (val) {
                    return val + '%'
                  }
                },
                startAngle: -90,
                endAngle: 270,
              }
            },
          },
        },
        labels: [],
        colors: [],
        stroke: {
          show: false,
          width: 0,
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: 'DM Sans',
          fontWeight: 600,
          markers: {
            width: 12,
            height: 12,
            radius: 12
          },
          onDatasetHover: {
            highlightDataSeries: false,
          },
        },
        tooltip: {
          enabled: false,
          y: {
            formatter: function (val) {
              return val + '%';
            }
          },
          style: {
            fontSize: '14px',
            fontFamily: 'DM Sans',
            fontWeight: 600,
          },
          onDatasetHover: {
            highlightDataSeries: false,
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: 'DM Sans',
            fontWeight: 600,
            colors: ['#fff']
          },
          dropShadow: {
            enabled: false
          },
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
    }

    this.toggle = this.toggle.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.toggleQuadrant = this.toggleQuadrant.bind(this);
    this.toggleEnergy = this.toggleEnergy.bind(this);

    const img = new Image();
    img.src = graphic_report_mask;
  }

  componentDidMount() {
    this.updateChartData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.team_report !== prevProps.team_report || this.props.quadrants !== prevProps.quadrants || this.state.energyAlways !== prevState.energyAlways) {
      this.updateChartData();
    }
  }

  updateChartData = () => {
    const { energyAlways } = this.state;
    const { team_report, quadrants } = this.props;

    if (!team_report || !quadrants) return;

    const seriesData = [];
    const colors = [];
    const labels = [];
    const labelsColors = [];

    const currentList = energyAlways ? team_report.thinking_talents_report : team_report.thinking_talents_report_never;

    currentList.forEach(item => {
      const quadrant = quadrants.find(quadrant => quadrant.id === item.quadrant_id);
      if (quadrant) {
        seriesData.push(item.percent);
        colors.push(quadrant.color);
        labels.push(item.quadrant_name);
        labelsColors.push(item.quadrant_name === QUADRANTS_INNOVATIVE ? '#332D2D' : 'white');
      }
    });

    this.setState({
      donutGraphOptions: {
        ...this.state.donutGraphOptions,
        series: seriesData,
        colors,
        labels,
        dataLabels: {
          style: {
            colors: labelsColors
          }
        },
        chart: {
          type: 'donut',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const clickedQuadrantName = labels[config.dataPointIndex];
              this.toggle(clickedQuadrantName);
            }
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                total: {
                  label: energyAlways ? 'Always Energy' : 'Never Energy',
                  fontSize: '14px',
                  fontFamily: 'DM Sans',
                  fontWeight: 700
                }
              }
            }
          }
        }
      }
    });
  }

  handleModal = (e, data, show_type) => {
    this.setState(prevState => ({
      show_modal: !prevState.show_modal,
      data_modal: data,
      show_type
    }));
  }

  toggle = (name) => {
    this.setState({
      show_modal: true,
      show_type: 'quadrant-detail',
      data_modal: name
    });
  }

  toggleEnergy = () => {
    const energyLabel = this.state.energyAlways ? "active-never" : "active-always";
    this.setState({
      energyAlways: !this.state.energyAlways,
      energyLabel: energyLabel
    });
  }

  toggleQuadrant = (id) => {
    this.setState(prevState => ({
      isOpen: prevState.quadrant_id === id ? false : true,
      quadrant_id: prevState.quadrant_id === id ? null : id
    }));
  }

  render() {
    const { show_modal, data_modal, energy_modal, show_type, donutGraphOptions, energyAlways, energyLabel } = this.state;
    const { quadrants, team, team_report, questions } = this.props;

    let content_modal = null;
    if (data_modal && show_type === 'members-list') {
      content_modal = <TalentsListMembers data={data_modal} energy={energy_modal} />;
    }
    else if (data_modal && show_type === 'quadrant-detail') {
      content_modal = <QuadrantsDetail
        items={questions.items}
        quadrant_name={data_modal}
        quadrants={quadrants}
        team_report={team_report}
      />;
    }

    const findTopTalentInQuadrants = ({ talentId }) => {
      for (const quadrant of team_report.thinking_talents_detail) {
        const foundTalent = quadrant.items.find(item => item.item_id === talentId);
        if (foundTalent) {
          return {
            ...foundTalent,
            quadrant_id: quadrant.quadrant_id,
            quadrant_name: quadrant.quadrant_name
          };
        }
      }
      return null;
    };

    const topTalents = ({ topTalentsItems, energy }) => {
      if (!topTalentsItems || topTalentsItems.size === 0) {
        return <div className="d-flex align-items-center mx-5 py-4"> 
          <p className="text-center"> No "{capitalizeFirstLetter(energy)}" talents feature more prominently within the team. </p>
        </div>;
      }

      return topTalentsItems.map(topTalent => {
        if (!team_report?.thinking_talents_detail) {
          return null;
        }

        const report_details_item = findTopTalentInQuadrants({
          talentId: topTalent.talent_id
        });

        if (!report_details_item) {
          return null;
        }

        return <div key={topTalent.talent_id} className="border rounded p-2 d-flex align-items-center mb-2 cursor-pointer"
          onClick={(e) => this.handleModal(e, { ...report_details_item, quadrant_id: topTalent.quadrant.id, energy }, 'members-list')}>
          <div className='d-flex align-items-center'>
            <i className={`icon d-inline-block mr-1 border rounded text-${energy} border-${energy}`}>
              <svg width="6" height="6" className='d-block'><circle cx="3" cy="3" r="3" fill="currentColor" /></svg>
            </i>
            <p className='mb-0 font-weight-semibold'>{topTalent.talent_name}</p>
          </div>
          <p className='ml-auto mb-0 font-weight-semibold small'>{topTalent.usage_stats.users_count}</p>
        </div>
      })
    }

    const topTalentsAlways = topTalents({
      topTalentsItems: this.props.topTalents?.always || [],
      energy: 'always'
    });

    const topTalentsNever = topTalents({
      topTalentsItems: this.props.topTalents?.never || [],
      energy: 'never'
    });

    return (
      <>
        <Row className='mb-3'>
          <Col>
            <div className='rounded border p-3 mb-3 mb-lg-0'>
              <h4 className='h5'>Quadrants Distributions</h4>
              <p>Distribution of selected thinking talents across all quadrants</p>
              <div className='mt-4 mx-auto'>

                <FormGroup className="d-flex align-items-center justify-content-center">
                  <div className='custom-switch-toggle'>

                    <Label className={`btn mb-0 font-weight-semibold ${energyLabel !== 'active-always' ? 'btn-green-light' : '' }`} for="energy-always">
                      Never Energy
                    </Label>

                    <CustomInput id="energy-always" type="switch" checked={energyAlways} onChange={this.toggleEnergy}/>

                    <Label className={`btn mb-0 font-weight-semibold ${energyLabel === 'active-always' ? 'btn-green-light' : ''}`} for="energy-always">
                      Always Energy
                    </Label>
                  </div>
                </FormGroup>

                <Chart options={donutGraphOptions} series={donutGraphOptions.series} type="donut" height={245}/>
              </div>
            </div>
          </Col>

          <Col>
            <div className='rounded border p-3'>
              <h4 className='h5'>Top Talents with Always and Never Energy</h4>
              <p>Most thinking talents selected for 'Always' or 'Never' energy across the team</p>

              {!this.props.topTalents?.isPending && <Row>
                <Col className='border-right'>
                  <div className="list-talents h-100">
                    {topTalentsAlways}
                  </div>
                </Col>
                <Col>
                  <div className="list-talents h-100">
                    {topTalentsNever}
                  </div>
                </Col>
              </Row>}

              <div className="d-lg-flex justify-content-between align-items-center mt-1 ml-md-1">
                <div className='d-flex justify-content-center justify-content-lg-start'>
                  <p className="mb-0 mr-3">
                    <i className="icon mr-2">
                      <svg width="16" height="16" className="mt-n1 text-always">
                        <circle cx="8" cy="8" r="8" fill="currentColor" />
                      </svg>
                    </i><span className='small'><strong> Always </strong></span>
                  </p>
                  <p className="mb-0 mr-3">
                    <i className="icon mr-2">
                      <svg width="16" height="16" className="mt-n1 text-never">
                        <circle cx="8" cy="8" r="8" fill="currentColor" />
                      </svg>
                    </i><span className='small'><strong> Never </strong></span>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Modal isOpen={show_modal} toggle={this.handleModal} size='sm' className={`w-100 modal-dialog-summary float-right ${show_type}`}>
          <ModalHeader toggle={this.handleModal} className='pb-0'></ModalHeader>
          <ModalBody className='pt-2'>
            <div className="d-flex align-items-center mb-3">
              <div className='mb-0 mr-3'><img className="rounded-circle" width="60" height="60" src={team.image || icon_members} alt={team.name} /></div>
              <h2 className="libre-caslon-text-regular text-capitalize mb-0 h4">{team.name}</h2>
            </div>
            {content_modal}
          </ModalBody>
        </Modal>
      </>
    )
  }
}

const mapStateToProps = (state, props) => {
  const currentTeamTopTalents = getCurrentTeamTopTalents(state);

  return {
    topTalents: currentTeamTopTalents
  };
};

const mapDispatchToProps = {
  
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThinkingTalents);